import React from 'react';

function CustomPagination({ totalItems, itemsPerPage, currentPage, onPageChange }) {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Determine page numbers to show
    const pageNumbers = [];
    if (totalPages <= 3) {
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(i);
        }
    } else {
        if (currentPage === 1) {
            pageNumbers.push(1, 2, 3);
        } else if (currentPage === totalPages) {
            pageNumbers.push(totalPages - 2, totalPages - 1, totalPages);
        } else {
            pageNumbers.push(currentPage - 1, currentPage, currentPage + 1);
        }
    }

    return (
        <nav>
            <ul className='pagination'>
                {/* Start Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <a onClick={() => onPageChange(1)} className='page-link'>
                        ««
                    </a>
                </li>

                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <a onClick={() => currentPage > 1 && onPageChange(currentPage - 1)} className='page-link'>
                        «
                    </a>
                </li>

                {pageNumbers.map(number => (
                    <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                        <a onClick={() => onPageChange(number)} className='page-link'>
                            {number}
                        </a>
                    </li>
                ))}

                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <a onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)} className='page-link'>
                        »
                    </a>
                </li>

                {/* End Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <a onClick={() => onPageChange(totalPages)} className='page-link'>
                        »»
                    </a>
                </li>
            </ul>
        </nav>
    );
}

export default CustomPagination;
